import React from 'react';
// import PropTypes from 'prop-types';
import Label from '../Label';

class TextInput extends React.Component {
  constructor(props) {
    super(props);
    this.getValue = this.getValue.bind(this);
    this.setControlState = this.setControlState.bind(this);
    this.renderLabel = this.renderLabel.bind(this);
    this.textControl = null;
    this.labelControl = null;
    this.errorControl = null;
    this.errorFlag = null;
    this.isControlStateValid = true;
  }
  componentWillReceiveProps(props) {
    if (!this.props.doNotUpdateOnPropsChange) {
      if (props.value) {
        this.setValue(props.value);
      }
    }
  }

  getValue() {
    if (this.textControl) {
      return this.textControl.value;
    }
    return '';
  }

  setValue(val) {
    if (this.textControl) {
      this.textControl.value = val;
    }
  }
  setFocus() {
    if (this.textControl) {
      this.textControl.focus();
    }
  }
  setControlState(isValildState, errorMessage, errorAttributes, calenderEror) {
    this.isControlStateValid = isValildState;
    if (isValildState) {
      this.textControl.classList.remove(errorAttributes.controlErrorClass);
      this.errorControl.classList.remove(errorAttributes.errorClass);
      this.errorControl.innerHTML = '';
    } else if (calenderEror) {
      this.errorControl.classList.add(errorAttributes.errorClass);
      this.errorControl.innerHTML = errorMessage;
    } else {
      this.errorFlag = true;
      // if(!this.props.createEvent){
      this.textControl.classList.add(errorAttributes.controlErrorClass);
      this.errorControl.classList.add(errorAttributes.errorClass);
      this.errorControl.innerHTML = errorMessage;
      if(this.props?.createEvent){
        this.errorControl.style.display = 'block';
      }
    }
  }


  clearError() {
  if (this.errorControl) {
    this.errorControl.innerHTML = '';
    this.errorControl.style.display = 'none'; // hide error
  }

  if (this.textControl) {
    const errorClass = this.props.errorAttributes?.controlErrorClass || 'error';
    if (this.textControl.classList.contains(errorClass)) {
      this.textControl.classList.remove(errorClass);
    }
  }

}
  renderLabel() {
    return (
      <React.Fragment>
        <Label
          htmlFor={this.props.htmlId}
          label={this.props.label}
          required={this.props.required}
          star={this.props.star}
          labelClassName={this.props.labelClassName}
          ref={lbl => this.labelControl = lbl}
          isAddressForm={this.props.isAddressForm}
        />
        {this.props.requiredLabel
          ? (
            <p
              style={{
                margin: '4px 12px -6px 0',
                fontSize: 12,
                color: this.props.isErrorMsg ? 'red' : '#A1A1A1',
                paddingBottom: '7px',
              }}
            >{
              this.props.requiredLabel}
            </p>
          )
          : null}
      </React.Fragment>
    );
  }

  render() {
    const searchErrorStyle = {
      fontSize: 12,
      color: '#f00',
      fontWeight: 200,
      marginTop: this.props.channel === 'wap' ? '-20px' : '',
      marginBottom: this.props.channel === 'wap' ? '20px' : '',
    };

    return (
      <React.Fragment>
        <div
          onClick={this.props.onClickHandler ? this.props.onClickHandler : null}
          className={this.props.parentClassName ? this.props.parentClassName : 'materialStyle'}
        >
          {this.props.beforeElement}
          <input
            id={this.props.htmlId}
            type={this.props.type}
            name={this.props.name}
            className={this.props.className}
            defaultValue={this.props.value ? this.props.value : null}
            number={this.props.Number}
            placeholder={this.props.placeholder}
            onChange={this.props.onChange}
            onKeyPress={this.props.onKeyPress}
            onKeyUp={this.props.onKeyUp}
            onKeyDown={this.props.onKeyDown}
            onPaste={this.props.onPaste}
            maxLength={this.props.maxlength}
            readOnly={this.props.readonly}
            style={this.props.style}
            disabled={this.props.disabled}
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
            required={this.props.required}
            ref={txt => this.textControl = txt}
            value={this.props.inputValue}
            min={this.props.min}
            inputMode={this.props.numeric}
          />
          {!this.props.placeholder ? this.renderLabel() : ''}
          {this.props.childElement}
          <span style={searchErrorStyle} ref={err => this.errorControl = err} />
        </div>
      </React.Fragment>
    );
  }
}

export default TextInput;
